"use strict";

var workflowConfigCtrl = [function () {
        var _this = this;
        _this.fields = [];
        _this.element = undefined; // Simplelist selected element

        // Certificación Digital
        this.typeList = [
            { id: 'point', name: 'Punto de Medición' },
            { id: 'consolidate', name: 'Documento de Medición' }
        ]

        _this.form.measurement = _this.form?.measurement || {
            company: undefined, // idField,
            asset: undefined, // idField,
            agreement: undefined, // idField,
            type: undefined, // “point” || “consolidate”,
            allowRevalidate: false, // true||false,
            pointsList: undefined,
            pointId: undefined,
            filter_1: undefined,
            filter_2: undefined,
            filter_3: undefined,
        }

        // Workflow
        _this.form.workflow = _this.form?.workflow || {
            geo: undefined,
            lockUser: undefined,
            reject: undefined,
            filterByIdleDays: 0,
            rejectByIdleDays: false,
            steps_approved: undefined,
            allowChange: [],
            steps: [],
        };

        // Compatibilidad: rejectByIdleDays era numérico; ahora filterByIdleDays es el número (0-31)
        // y rejectByIdleDays es boolean (default false)
        if (!_this.form.workflow.hasOwnProperty('filterByIdleDays')) {
            const legacyIdleDays = Number(_this.form.workflow.rejectByIdleDays) || 0;
            _this.form.workflow.filterByIdleDays = Math.min(90, Math.max(0, legacyIdleDays));
            _this.form.workflow.rejectByIdleDays = legacyIdleDays > 0;
        }
        if (typeof _this.form.workflow.rejectByIdleDays !== 'boolean') {
            _this.form.workflow.rejectByIdleDays = false;
        }
        _this.form.workflow.filterByIdleDays = Math.min(90, Math.max(0, Number(_this.form.workflow.filterByIdleDays) || 0));

        _this.idleDaysRange = [];
        for (let i = 0; i <= 90; i++) {
            _this.idleDaysRange.push(i);
        }

        _this.measu = _this.form.measurement;
        _this.wf = _this.form.workflow;
        _this.form.pages.forEach((page) => {
            let fields = page.fields.flatMap((x) =>
                x.type == "group" ? x.nodes : x
            );
            _this.fields = _this.fields.concat(fields);
        });
        _this.geoFilter = (field) => {
            return ["geo", "text", "select"].includes(field.type);
        };
        _this.allowChangeFilter = (field) => {
            return (
                ["autonumeric", "sign"].includes(field.type) == false &&
                !field.templateData?.hidden && !field.isArchived
            );
        };

        _this.setAllowChangeField = (fieldId) => {
            if (_this.wf.allowChange.includes(fieldId))
                _this.wf.allowChange.splice(_this.wf.allowChange.indexOf(fieldId), 1)
            else
                _this.wf.allowChange.push(fieldId)
        }

        _this.newStep = () => {
            _this.wf.steps.push({ member: undefined, checkStepON: undefined });
        };
        _this.removeStep = (index) => {
            _this.wf.steps.splice(index, 1);
        };

        // function loadFromMetadata() {
        //     let steps = -1;
        //     let members = "";
        //     let checks = "";

        //     _this.form.metadata.forEach((meta) => {
        //         if (meta.key == "PTW" && meta.value && meta.value != "0")
        //             _this.form.type = "ptw";
        //         if (meta.key == "PTW_GEO" && meta.value && meta.value != "")
        //             _this.wf.geo = meta.value.trim();
        //         if (meta.key == "PTW_REJECT" && meta.value && meta.value != "")
        //             _this.wf.reject = meta.value.trim();
        //         if (meta.key == "PTW_STEPS" && meta.value && meta.value != "")
        //             steps = parseInt(meta.value);
        //         if (
        //             meta.key == "PTW_STEPAPPROVED" &&
        //             meta.value &&
        //             meta.value != ""
        //         )
        //             _this.wf.steps_approved = parseInt(meta.value);
        //         if (meta.key == "PTW_MEMBERS" && meta.value && meta.value != "")
        //             members = meta.value.split(",");
        //         if (meta.key == "PTW_CHECKS" && meta.value && meta.value != "")
        //             checks = meta.value.split(",");
        //         if (meta.key == "PTW_ALLOWCHANGE" && meta.value && meta.value != "")
        //             _this.wf.allowChange = meta.value.split(",");
        //     });
        //     for (let i = 0; i < steps; i++) {
        //         _this.wf.steps.push({
        //             member: members[i].trim(),
        //             checkStepON: checks[i].trim(),
        //         });
        //     }
        // }

        // On Simple List Select change
        this.onSimpleListChange = () => {
            _this.measu.pointId = ''; // reinit pointId value
            if (_this.measu.pointsList) {
                _this.element = _this.inputElementsForFormSimpleList.find(e => e.id === _this.measu.pointsList)
                if (_this.element) {
                    this.getFlattenedInputElementsSimpleListChilds(_this.form);
                }
            }
        }

        // On init if element simple list is selected 
        this.getFlattenedInputElementsSimpleListChildsInit = () => {
            if (_this.measu.pointsList) {
                _this.element = _this.findElementByIdInForm(_this.form, _this.measu.pointsList);
                if (_this.element) {
                    _this.inputElementsForFormSimpleListChilds = this.getFlattenedInputElementsSimpleListChilds(_this.form);
                }
            }
        }

        this.findElementByIdInForm = function (form, id) {
            for (let page of form.pages) {
                for (let field of page.fields) {
                    if (field.id === id) {
                        return field;
                    }
                }
            }
            return null;
        };

        this.getFlattenedInputElementsSimpleListChilds = function (form) {
            const processPages = function(pages, formType) {
                let flattenedElements = [];
        
                pages.forEach((page, pageIndex) => {
                    const elementsWithLevels = _this.getElementsWithLevelsForPopulate(page.fields, pageIndex, 1, formType);
                    flattenedElements = flattenedElements.concat(elementsWithLevels);
                });
                return flattenedElements;
            };
    
            let lstFields = form.pages
            let flattenedPages = [];
            if (this.element?.type == 'simplelist') {
                lstFields = [{ fields: this.element.nodes }];
                let el = JSON.parse(JSON.stringify(this.element));
                // Nombre a mostrar
                let listName = (el.name || el.label)  + ' \(' + el.type + ' - ' + el.id + '\)';
                flattenedPages = processPages(lstFields, listName);
            }
        
            let flattenedElements = flattenedPages.filter(function (element) {
                if (element.id === _this.element.id) {
                    return false;
                }
                switch (element.type) {
                    case 'text':
                    case 'sendemail':
                    case 'autonumeric':
                    case 'number':
                    case 'select':
                    case 'date':
                    case 'time':                
                    case 'timestamp':
                    case 'checkbox':
                    case 'multiple':
                    case 'geo':
                    case 'sign':
                    case 'qr':
                    case 'simplelist':
                    case 'group':
                        return true;
                    default:
                        return false;
                }
            })
            return flattenedElements;
        };
       
        this.getElementsWithLevelsForPopulate = function (fields, pageIndex, level, formType) {
            return fields.flatMap(function (field) {
                // if (field.type === 'simplelist') {
                //     const currentField = {
                //         ...field,
                //         level: level,
                //         disabled: false,
                //         form: formType,
                //         page: `Página ${pageIndex + 1}`
                //     };
                //     // NO SE PROCESAN LOS ELEMENTOS DENTRO DE SIMPLELIST
                //     // Procesar los nodos dentro del 'simplelist' después de 'simplelist'
                //     // const nodesProcessed = _this.getElementsWithLevels(field.nodes, pageIndex, level + 1, formType);
                //     return [currentField];
                // }
    
                const isElementInSimpleList = function(nodes) {
                    return nodes.some(node => {
                        if (node.id === _this.element.id) {
                            return true;
                        }
                        if (node.nodes && node.nodes.length > 0) {
                            return isElementInSimpleList(node.nodes);
                        }
                        return false;
                    });
                };
    
                if (field.type === 'simplelist') {
                    const elementInCurrentSimpleList = field.id === _this.element.id || isElementInSimpleList(field.nodes || []);
    
                    const currentField = {
                        ...field,
                        level: level,
                        disabled: false,
                        form: formType,
                        page: `Página ${pageIndex + 1}`
                    };
                    const nodesProcessed = elementInCurrentSimpleList
                        ? _this.getElementsWithLevelsForFormDyn(field.nodes, pageIndex, level + 1, formType)
                        : [];
    
                    return [currentField].concat(nodesProcessed);
                }
    
                if (field.type === 'group') {
                    const currentField = {
                        ...field,
                        level: level,
                        disabled: false,
                        form: formType,
                        page: `Página ${pageIndex + 1}`
                    };
                    // Procesar los nodos dentro de 'group' despues de 'group'
                    const nodesProcessed = _this.getElementsWithLevelsForPopulate(field.nodes, pageIndex, level + 1, formType);
                    return [currentField].concat(nodesProcessed);
                }
                return [{ ...field, level: level, disabled: false, form: formType, page: `Página ${pageIndex + 1}` }];
            });
        };

        this.getFlattenedInputElements = function (form, simplelist, init) {
            const processPages = function (pages, formType) {
                let flattenedElements = [];

                pages.forEach((page, pageIndex) => {
                    const elementsWithLevels = _this.getElementsWithLevels(page.fields, pageIndex, 1, formType);
                    flattenedElements = flattenedElements.concat(elementsWithLevels);
                });

                return flattenedElements;
            };

            let flattenedPages = processPages(form.pages, "Formulario");
            // return flattenedPages;

            if (!simplelist) {
                return flattenedPages.filter(function (element) {
                    switch (element.type) {
                        case 'text':
                        case 'select':
                        case 'multiple':
                        case 'formula':
                        case 'date':
                        case 'timestamp':
                        case 'checkbox':
                        case 'geo':
                        case 'group':
                            return true;
                        default:
                            return false;
                    }
                })
            } else {
                return flattenedPages.filter(function (element) {
                    switch (element.type) {
                        case 'simplelist':
                            return true;
                        default:
                            return false;
                    }
                })
            }
        };
        this.getElementsWithLevels = function (fields, pageIndex, level, formType) {
            return fields.flatMap(function (field) {
                if (field.type === 'simplelist') {
                    const currentField = {
                        ...field,
                        level: level,
                        disabled: false,
                        form: formType,
                        page: `Página ${pageIndex + 1}`
                    };
                    // NO SE PROCESAN LOS ELEMENTOS DENTRO DE SIMPLELIST
                    // Procesar los nodos dentro del 'simplelist' después de 'simplelist'
                    // const nodesProcessed = _this.getElementsWithLevels(field.nodes, pageIndex, level + 1, formType);
                    return [currentField]
                }
                if (field.type === 'group') {
                    const currentField = {
                        ...field,
                        level: level,
                        disabled: false,
                        form: formType,
                        page: `Página ${pageIndex + 1}`
                    };
                    // Procesar los nodos dentro de 'group' despues de 'group'
                    const nodesProcessed = _this.getElementsWithLevels(field.nodes, pageIndex, level + 1, formType);
                    return [currentField].concat(nodesProcessed);
                }
                return [{ ...field, level: level, disabled: false, form: formType, page: `Página ${pageIndex + 1}` }];
            });
        };
        this.getListFieldLabel = (field) => {
            var level = Math.max(0, (field.level || 1) - 1);
            var indent = level ? "\u00A0\u00A0\u00A0\u00A0".repeat(level) : "";
            var label = indent + (field.name || field.label || "");
            if (field.type) {
                label += " (" + field.type + " - " + field.id + ")";
            }
            return label;
        };

        this.isWorkflowElementDisabled = (element, allowedTypes) => {
            if (element.type === 'group') {
                return true;
            }
            return !allowedTypes.includes(element.type);
        };

        this.inputElementsForForm = this.getFlattenedInputElements(this.form);
        this.inputElementsForFormSimpleList = this.getFlattenedInputElements(this.form, true, true);
        
        // For simple list childs init
        this.inputElementsForFormSimpleListChilds = [];
        this.getFlattenedInputElementsSimpleListChildsInit();

        // _this.wf.steps.length == 0 && Array.isArray(_this.form.metadata) && loadFromMetadata(); //ESTO DEBERIA SER TEMPORAL HASTA ACTUALIZAR LA APP
    },
];

module.exports = function () {
    return {
        restrict: "E",
        scope: {
            form: "=",
            integrations: "=",
        },
        replace: true,
        controller: workflowConfigCtrl,
        controllerAs: "ctrl",
        bindToController: true,
        templateUrl:
            "dashboard-builder/workflowConfig/workflowConfigDirective.html",
    };
};
